import type { Channel } from "@sobidogam/platform-ports";
import { Header, SiteFooter } from "./chrome";
import { HelpSearch } from "./HelpSearch";
import { SUPPORT_EMAIL } from "./IssueReport";

/** Effective date of this revision = the production deploy date. */
export const LEGAL_EFFECTIVE_DATE = "2026년 10월 17일";
/** 사업자 표기: hq/bootstrap/identity.yaml business_trade_name_ko. */
const OPERATOR = "문옵스(MUNOPS)";

function Privacy() {
	return (
		<>
			<p className="legal-effective-date">시행일 {LEGAL_EFFECTIVE_DATE}</p>
			<p>
				{OPERATOR}(이하 '운영자')는 소비도감을 운영하며 개인정보 보호법에 따라
				이용자의 개인정보를 이렇게 처리합니다. 소비도감은 계정을 만들지 않고,
				이름·연락처·생년월일·주소·카드번호·승인번호를 수집하지 않습니다.
			</p>
			<h2>1. 처리 목적</h2>
			<ul>
				<li>소비 기록·리포트·장보기 같은 기능 제공(이 기기 안에서 처리)</li>
				<li>서비스 개선을 위한 익명 사용 통계</li>
				<li>문의 응대와 오류 확인</li>
				<li>유료 상품을 연 뒤의 구매 확인과 복원</li>
			</ul>
			<h2>2. 처리 항목과 어디에 남는지</h2>
			<table className="legal-table">
				<thead>
					<tr>
						<th scope="col">항목</th>
						<th scope="col">남는 곳</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							확인한 매장·금액·시각·분류, 메모·태그, 집 안 물건·장보기, 한도,
							설정
						</td>
						<td>이 기기 안(브라우저 저장소). 서버로 보내지 않아요.</td>
					</tr>
					<tr>
						<td>붙여 넣은 결제 알림, 문자 공유로 들어온 글, 가져온 파일</td>
						<td>
							이 기기 안에서 읽고 바로 버려요. 확인한 값만 기록으로 남아요.
						</td>
					</tr>
					<tr>
						<td>
							익명 사용 통계: 이벤트 이름, 채널(웹·토스), 구간값(예: 첫 기록까지
							30초 안), 방문 경로, 유입 출처, 시각
						</td>
						<td>
							Cloudflare 통계 저장소. 기기 식별값은 저장하지 않고,
							매장·금액·메모·알림 원문은 보내지 않아요.
						</td>
					</tr>
					<tr>
						<td>문의 메일에 적은 내용과 메일 주소</td>
						<td>운영자 메일함</td>
					</tr>
					<tr>
						<td>
							유료 상품을 연 뒤: 기기 식별값의 해시, 구매한 상품과 시각(토스
							익명 키 기반)
						</td>
						<td>
							Cloudflare 데이터베이스. 결제가 열리기 전에는 보관하지 않아요.
						</td>
					</tr>
				</tbody>
			</table>
			<h2>3. 보유 기간과 파기</h2>
			<ul>
				<li>
					기기 안 기록: 이용자가 지우거나 브라우저 데이터를 지울 때까지. 설정의
					'전체 삭제'로 바로 지울 수 있어요.
				</li>
				<li>익명 사용 통계: 수집일부터 최대 3개월 뒤 자동 삭제</li>
				<li>문의 메일: 답변 완료 후 1년 뒤 삭제</li>
				<li>
					구매 기록: 전자상거래법에 따라 대금 결제·재화 공급 기록 5년 보관 후
					삭제
				</li>
				<li>
					파기는 전자 파일을 복구할 수 없는 방법으로 지우는 방식으로 해요.
				</li>
			</ul>
			<h2>4. 처리 위탁과 국외 이전</h2>
			<p>
				소비도감은 Cloudflare, Inc.(미국)에 웹 호스팅, 익명 사용 통계 저장, 사진
				글자 읽기(아래)를 맡겨요. Cloudflare는 전 세계 데이터센터에서 요청을
				처리하므로, 서비스 이용 시점에 위 2절의 서버 항목이 국외에서 처리될 수
				있어요. 이전 방법은 네트워크 전송이고, 보유 기간은 3절과 같아요. 국외
				이전을 원하지 않으면 설정에서 사용 통계 보내기를 끌 수 있어요. 기록
				기능은 그대로 쓸 수 있어요.
			</p>
			<h2>5. 영수증 사진 자동 읽기</h2>
			<p>
				사진 자동 읽기는 지금 꺼져 있어요. 꺼져 있는 동안 사진은 서버로 가지
				않고, 사진을 보며 직접 입력하는 화면으로 이어져요. 켜질 때에는 읽는
				순간에만 사진을 Cloudflare Workers AI로 보내고, 읽은 직후 지우며
				저장하지 않아요. 사진 선택 전에 AI 사용 사실을 알리고, 읽은 결과에는
				'AI가 읽은 값'이라고 표시해요.
			</p>
			<h2>6. 백업과 공유 카드</h2>
			<p>
				복구코드 백업은 이 기기에서 암호화한 파일로만 만들어요. 지금은 서버
				백업을 쓰지 않아요. 공유 카드 이미지는 기기에서 만들고 서버에 올리지
				않아요.
			</p>
			<h2>7. 민감한 업종</h2>
			<p>
				약국·병의원·치과·한의원·건강검진 기록은 품목과 메모를 저장하지 않고,
				매장 이름도 업종 이름으로 바꿔 총액만 남겨요. 이 칸은 공유 카드를 만들지
				않아요.
			</p>
			<h2>8. 토스 앱 알림</h2>
			<p>
				토스 앱에서 알림에 동의하면 토스가 알림 발송에 필요한 정보를 처리해요.
				소비도감은 이름·연락처를 받지 않으며, 동의는 토스 설정에서 언제든 거둘
				수 있어요. 밤 10시~아침 8시에는 보내지 않아요.
			</p>
			<h2>9. 이용자의 권리와 행사 방법</h2>
			<p>
				이용자는 자기 개인정보의 열람·정정·삭제·처리정지를 요구할 수 있어요.
				기기 안 기록은 앱에서 직접 내려받고(CSV·JSON) 고치고 지울 수 있어요. 그
				밖의 요구는 {SUPPORT_EMAIL}로 보내 주시면 10일 안에 처리해요.
			</p>
			<h2>10. 안전성 확보 조치</h2>
			<ul>
				<li>기록을 서버가 아닌 기기 안에 두는 구조</li>
				<li>백업 파일 암호화(복구코드가 없으면 열 수 없음)</li>
				<li>전송 구간 암호화(HTTPS), 통계 항목 허용 목록 검사</li>
				<li>서버 접근 권한 최소화</li>
			</ul>
			<h2>11. 개인정보 보호책임자</h2>
			<p>
				{OPERATOR} 개인정보 보호 담당 · {SUPPORT_EMAIL}. 개인정보 침해
				신고·상담은 개인정보침해신고센터(국번 없이 118),
				개인정보분쟁조정위원회(1833-6972)에도 할 수 있어요.
			</p>
			<h2>12. 바뀌면 알리는 방법</h2>
			<p>
				이 방침을 바꾸면 이 페이지와 업데이트 소식에 알려요. 이용자에게 불리하게
				바뀌는 내용은 시행 7일 전에 알려요.
			</p>
		</>
	);
}

function Terms() {
	return (
		<>
			<p className="legal-effective-date">시행일 {LEGAL_EFFECTIVE_DATE}</p>
			<p>
				소비도감은 {OPERATOR}가 운영하는 소비 기록 서비스예요.
				현금·포인트·캐시백 같은 금전적 보상을 주지 않아요.
			</p>
			<h2>제1조 기록의 정확성</h2>
			<p>
				알림 해석과 분류 추정, AI가 읽은 값도 저장 전 최종 확인은 이용자가 해요.
				카드 명세와 맞춰 보기의 차이는 참고용이며 금융·세무 판단의 근거가
				아니에요.
			</p>
			<h2>제2조 무료 범위</h2>
			<p>
				기록·고치기·리포트·한도·달력·장보기·내보내기는 무료이고, 이 기능을
				광고나 결제로 막지 않아요.
			</p>
			<h2>제3조 유료 상품</h2>
			<ul>
				<li>
					기억 보관함 평생권 9,900원, 연간 기억책 2,900원. 모두 한 번 구매하는
					디지털 콘텐츠이고 구독이 아니어서 자동 결제·해지 대상이 없어요.
				</li>
				<li>결제는 토스 앱의 인앱 결제로만 받아요. 지금은 준비 중이에요.</li>
				<li>
					청약철회: 구매 후 7일 안에 철회할 수 있어요. 다만 구매한 콘텐츠를
					열람·내려받은 뒤에는 전자상거래법 제17조 제2항 제5호에 따라 철회가
					제한돼요. 내용이 설명과 다르면 공급받은 날부터 3개월, 그 사실을 안
					날부터 30일 안에 철회할 수 있어요.
				</li>
				<li>
					환불: 토스 앱 결제 내역에서 요청하거나 {SUPPORT_EMAIL}로 알려 주세요.
					확인 후 3영업일 안에 결제 수단으로 돌려드려요.
				</li>
				<li>
					복원: 기기를 바꾸면 '소비도감 플러스 → 이전에 구매했다면 복원'으로
					되찾아요.
				</li>
			</ul>
			<h2>제4조 데이터 보존</h2>
			<p>
				정책이나 유료 범위가 바뀌어도, 서비스를 끝내더라도 이미 저장한 기록을
				지우거나 열람·내보내기를 막지 않아요. 서비스를 끝낼 때는 30일 전에
				알려요.
			</p>
			<h2>제5조 문의</h2>
			<p>
				문제가 있으면 {SUPPORT_EMAIL}로 알려 주세요. 평일 3일 안에 답장하는 것을
				목표로 해요.
			</p>
		</>
	);
}

export function LegalPage({
	kind,
	channel,
	onHelpSearch,
	onIssueOpen,
}: {
	kind: "privacy" | "terms" | "support";
	channel: Channel;
	onHelpSearch?: (resultCount: number) => void;
	onIssueOpen?: () => void;
}) {
	const content = {
		privacy: { eyebrow: "내 데이터", title: "개인정보 처리방침" },
		terms: { eyebrow: "이용 약속", title: "이용약관" },
		support: { eyebrow: "도움말", title: "무엇을 도와드릴까요?" },
	}[kind];
	return (
		<>
			<Header channel={channel} />
			<main className="section-wrap legal-page">
				<p className="eyebrow">{content.eyebrow}</p>
				<h1>{content.title}</h1>
				<div className="legal-copy">
					{kind === "privacy" ? <Privacy /> : null}
					{kind === "terms" ? <Terms /> : null}
					{kind === "support" ? (
						<>
							<HelpSearch
								channel={channel}
								initialId={
									typeof window === "undefined"
										? undefined
										: window.location.hash.slice(1) || undefined
								}
								{...(onHelpSearch ? { onSearch: onHelpSearch } : {})}
								{...(onIssueOpen ? { onIssueOpen } : {})}
							/>
							<p className="notice notice-sage">
								기록 원문이나 복구코드는 보내지 말고, 사용한 기기와 문제가 생긴
								화면만 적어 주세요. {SUPPORT_EMAIL} · 평일 3일 안에 답장을
								목표로 해요.
							</p>
						</>
					) : null}
				</div>
			</main>
			<SiteFooter />
		</>
	);
}
